import React from 'react';
import "@abank/alias-color/AliasColor.less";

export default function template(props) {
  const { title, inputName, value, currency, min, max, step, onInputChange, onInputBlur, onRangeChange,hiddenValueRef, currencyOffset, showError, errorText, readOnly, titleNote } = props;

  return (
    <div className="calculator-new__controllers controllers-calculator-new">
      <div className="controllers-calculator-new__title">
        {title}<span>{titleNote}</span>
      </div>
      <div className="controllers-calculator-new__slider slider-controllers-calculator-new">
        <div className="slider-controllers-calculator-new__value">
          <div className="slider-controllers-calculator-new__input">
            <input
              className="slider-controllers-calculator-new__text-input"
              name={inputName}
              type="text"
              value={value.toLocaleString('uk-UA')}
              onChange={onInputChange}
              onBlur={onInputBlur}
              max={max}
              min={min}
              readOnly={readOnly}
            />
            <span
              ref={hiddenValueRef}
              className="slider-controllers-calculator-new__hidden-value"
            >
              {value.toLocaleString('uk-UA')}
            </span>
            {currency && (
              <span
                className="slider-controllers-calculator-new__currency"
                style={{ left: `${currencyOffset}px` }}
              >
                {currency}
              </span>
            )}
          </div>
        </div>
        <div className="slider-controllers-calculator-new__range">
          <input
            type="range"
            className="slider-controllers-calculator-new__range-input"
            name={inputName}
            onChange={onRangeChange}
            value={value}
            min={min}
            max={max}
            step={step}
            style={{
              '--range-percent-value': (value - min) / (max - min)
            }}
          />
        </div>
        {showError && (
          <div className="slider-controllers-calculator-new__error">{errorText}</div>
        )}
      </div>
    </div>
  );
}
